import { eFeePropertyNames } from '../../../../../types/order/fees/eFeePropertyNames';
import React from 'react';
import { ICreateSettlementFeeForm } from '../../../../../types/order/fees/ICreateSettlementItemForm';
import { PercentageOfLoanAmount } from './fields/PercentageOfLoanAmount';
import { PageCount } from './fields/PageCount';
import { RatePerMonth } from './fields/RatePerMonth';
import { NumberOfMonths } from './fields/NumberOfMonths';
import { DateFrom } from './fields/DateFrom';
import { DateTo } from './fields/DateTo';
import { DayRate } from './fields/DayRate';
import { GoodThruDate } from './fields/GoodThruDate';
import { PerDiem } from './fields/PerDiem';
import { BillingPeriod } from './fields/BillingPeriod';
import { Amount } from './fields/Amount';
import { BillingAmount } from './fields/BillingAmount';
import { ReasonField } from './fields/ReasonField';
import { RecordingParty } from './fields/RecordingParty';

export interface IConditionalFeeFields {
  properties: any;
  baseName: string;
  fee: ICreateSettlementFeeForm;
  readOnly: boolean;
}

export const ConditionalFeeFields: React.FC<IConditionalFeeFields> = ({ properties, baseName, fee, readOnly }) => {
  return (
    <>
      {properties[eFeePropertyNames.PercentageOfLoanAmount] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <PercentageOfLoanAmount baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.PageCount] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <PageCount baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.BillingPeriod] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <BillingPeriod baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.BillingAmount] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <BillingAmount baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.RatePerMonth] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <RatePerMonth baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.NumberOfMonths] && (
        <div className={'flex-grow basis-2/12 p-1'}>
          <NumberOfMonths baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.GoodThruDate] && (
        <div className={'flex-grow basis-32 p-1'}>
          <GoodThruDate baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.Amount] && !properties[eFeePropertyNames.BuyerPaidAtClosing] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <Amount baseName={baseName} readOnly={readOnly} fee={fee} />
        </div>
      )}
      {properties[eFeePropertyNames.Reason] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <ReasonField baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.DateFrom] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <DateFrom baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.DateTo] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <DateTo baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.DayRate] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <DayRate baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.PerDiem] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <PerDiem baseName={baseName} readOnly={readOnly} />
        </div>
      )}
      {properties[eFeePropertyNames.RecordingParty] && (
        <div className={'flex-grow basis-1/12 p-1'}>
          <RecordingParty baseName={baseName} readOnly={readOnly} />
        </div>
      )}
    </>
  );
};
